module.exports = __webpack_public_path__ + "img/layers_icon_251258.4e7fd0fe.png";